module.exports = __webpack_public_path__ + "media/images/latest-update-9e5505edad14c07252df78236f47c389.jpg";